import { empty, singleton, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import * as react from "react";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";

export function view(model, dispatch, navigateTo) {
    const children_2 = toList(delay(() => {
        let props;
        return (model.BeratungsterminUrl !== "") ? singleton((props = [new HTMLAttr(149, [model.BeratungsterminUrl]), ["style", {
            width: "100%",
            height: "100%",
            border: "0",
            marginTop: "10px",
        }], ["scrolling", "yes"]], react.createElement("iframe", keyValueList(props, 1)))) : empty();
    }));
    return react.createElement("div", {
        className: "full-height",
    }, ...children_2);
}

//# sourceMappingURL=View.fs.js.map
